module.exports = __webpack_public_path__ + "static/media/logo.87d083f8.svg";